<template>
	<div class="zhuanti">
		<div class="zhuanti_con">
			<div class="zhuanti_l" style="margin-left:10px;min-width:300px;">
				<div class="sec_name">组件区</div>
				<div class="tool_list setting">
					<div class="tool_item" @click="showSetBgModal = true">
						<div class="">
							<Icon type="ios-color-palette" size="24" class="cursor" />
						</div>
						<div class="name">背景色</div>
					</div>
					<div class="tool_item" @click="previewFun">
						<div class="">
							<Icon type="md-sync" size="24" class="cursor" />
						</div>
						<div class="name">预览</div>
					</div>
					<div class="tool_item" @click="publishFun">
						<div class="">
							<Icon type="md-swap" size="24" class="cursor" />
						</div>
						<div class="name">发布</div>
					</div>
				</div>
				<div class="tool_list">
					<div class="tool_item">
						<div class="tool_item_t">
							<div class="name">图片</div>							
							<Icon type="ios-add-circle" size="24" class="cursor" @click="onShowImg(0)" />
						</div>
						<div class="tool_item_m">
							<div>示例：</div>
							<div class="tool_item_tu" @click="showViewerFun('/img/zhuanti/ex-img.png')">
								<img class="example-tu" src="/img/zhuanti/ex-img.png" alt="">
							</div>	
						</div>	
					</div>
					<div class="tool_item">
						<div class="tool_item_t">
							<div class="name">视频</div>
							<Icon type="ios-add-circle" size="24" class="cursor" @click="onShowVideo(0)" />
						</div>
						<div class="tool_item_m">
							<div>示例：</div>
							<div class="tool_item_tu" @click="showViewerFun('/img/zhuanti/ex-video.png')">
								<img class="example-tu" src="/img/zhuanti/ex-video.png" alt="">
							</div>
						</div>
					</div>
					<div class="tool_item">
						<div class="tool_item_t">
							<div class="name">竖排</div>
							<Icon type="ios-add-circle" size="24" class="cursor" @click="onShowList(0,4)" />
						</div>
						<div class="tool_item_m">
							<div>示例：</div>
							<div class="tool_item_tu" @click="showViewerFun('/img/zhuanti/ex-shupai.png')">
								<img class="example-tu" src="/img/zhuanti/ex-shupai.png" alt="">
							</div>
						</div>
					</div>
					<div class="tool_item">
						<div class="tool_item_t">
							<div class="name">横排</div>
							<Icon type="ios-add-circle" size="24" class="cursor" @click="onShowList(0,5)" />
						</div>
						<div class="tool_item_m">
							<div>示例：</div>
							<div class="tool_item_tu" @click="showViewerFun('/img/zhuanti/ex-hengpai.png')">
								<img class="example-tu" src="/img/zhuanti/ex-hengpai.png" alt="">
							</div>
						</div>	
					</div>
					<div class="tool_item">
						<div class="tool_item_t">
							<div class="name">分类</div>
							<Icon type="ios-add-circle" size="24" class="cursor" @click="onShowTab(0)" />
						</div>
						<div class="tool_item_m">
							<div>示例：</div>
							<div class="tool_item_tu" @click="showViewerFun('/img/zhuanti/ex-cate.png')">
								<img class="example-tu" src="/img/zhuanti/ex-cate.png" alt="">
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 编辑区 -->
			<div class="" style="margin-left:60px;min-width:375px;">
				<div class="sec_name">编辑区</div>
				<div class="content sec-edit" v-if="zhuantiData && zhuantiData.length">
					<div class="content-item" v-for="(item,index) in zhuantiData" :key="index">
						<!-- 编辑 删除 -->
						<div class="action-wrap">
							<Button type="success" @click="editFun(item)">编辑</Button>
							<Button type="success" v-if="index != 0" @click="moveFun(item,1,false)">上移</Button>
							<Button type="success" v-if="index != zhuantiData.length-1" @click="moveFun(item,0,false)">下移</Button>
							<Button type="error" @click="delFun(item,0)">删除</Button>
						</div>
						<!-- 图片 -->
						<div class="con-section" v-if="item.type_id == 1">
							<img :src="$publicData.ossUrl+item.content.thumb" alt="" class="">
						</div>
						<!-- 视频 -->
						<div class="con-section" v-if="item.type_id == 2">
							<video width="280" controls :src="$publicData.ossUrl+item.content.link" :poster="$publicData.ossUrl+item.content.thumb"></video>
						</div>
						<!-- 竖排 -->
						<div class="con-section" v-if="item.type_id == 4">
							<div class="goods-list">
								<div class="goods-item" v-for="(goods,index) in item.content" :key="index">
									<img :src="$publicData.ossUrl+goods.thumb" alt="" class="">
								</div>
							</div>
						</div>
						<!-- 横排 -->
						<div class="con-section" v-if="item.type_id == 5">
							<div class="scroll-wrap" ref="scrollDom">
								<div class="yuekan-list">
									<div class="yuekan-item" v-for="(yuekan,index) in item.content" :key="index">
										<img :src="$publicData.ossUrl+yuekan.thumb" alt="">
									</div>
								</div>
							</div>
						</div>
						<div class="tab-wrap-sec" v-if="item.type_id == 3">	
							<div class="scroll-wrap" ref="scrollDom">
								<div class="tab-wrap">
									<div :class="fenlei.status ? 'tab-item cursor active ': 'tab-item cursor'" v-for="(fenlei,tabIndex) in item.cate" :key="tabIndex" @click="selectTabFun(item.block_id,fenlei.cate_id)">{{ fenlei.content }}</div>
								</div>
							</div>	
							<!-- tab内容 -->
							<div class="content-item" v-for="(tabItem,index) in item.currentFenlei" :key="index">
								<!-- 编辑 删除 -->
								<div class="action-wrap">
									<Button type="success" @click="editFun(tabItem)">编辑</Button>
									<Button type="success" v-if="index != 0" @click="moveFun(tabItem,1,true)">上移</Button>
									<Button type="success" v-if="index != item.currentFenlei.length-1" @click="moveFun(tabItem,0,true)">下移</Button>
									<Button type="error" @click="delFun(tabItem,1)">删除</Button>
								</div>
								<!-- 图片 -->
								<div class="con-section" v-if="tabItem.type_id == 1">
									<img :src="$publicData.ossUrl+tabItem.content.thumb" alt="" class="">
								</div>
								<!-- 视频 -->
								<div class="con-section" v-if="tabItem.type_id == 2">
									<video width="280" controls :src="$publicData.ossUrl+tabItem.content.link" :poster="$publicData.ossUrl+tabItem.content.thumb"></video>
								</div>
								<!-- 竖排 -->
								<div class="con-section goods-list" v-if="tabItem.type_id == 4">
									<div class="goods-item" v-for="(goods,index) in tabItem.content" :key="index">
										<img :src="$publicData.ossUrl+goods.thumb" alt="" class="">
									</div>
								</div>
								<!-- 横排 -->
								<div class="con-section" v-if="tabItem.type_id == 5">
									<div class="scroll-wrap" ref="scrollDom">
										<div class="yuekan-list">
											<div class="yuekan-item" v-for="(yuekan,index) in tabItem.content" :key="index">
												<img :src="$publicData.ossUrl+yuekan.thumb" alt="">
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>						
					</div>
				</div>
			</div>
			<!-- 预览 -->
			<div class="" style="margin-left:60px;min-width:375px;">
				<div class="sec_name">预览区 ( {{ $publicData.H5Url +'/zhuanti/detail?id='+ this.zhuanti_id }} )</div>
				<div class="content preview" v-if="zhuantiDataPre" :style="'background:'+bgColorSetVal">
					<div class="content-item" v-for="(item,index) in zhuantiDataPre" :key="index">
						<div class="con-section" v-if="item.type_id == 1">
							<img :src="$publicData.ossUrl+item.content.thumb" alt="" class="">
						</div>
						<div class="con-section" v-if="item.type_id == 2">
							<video style="width:100%;" controls :src="$publicData.ossUrl+item.content.link" :poster="$publicData.ossUrl+item.content.thumb"></video>
						</div>
						<div class="con-section" v-if="item.type_id == 4">
							<div class="goods-list">
								<div class="goods-item" v-for="(goods,index) in item.content" :key="index">
									<img :src="$publicData.ossUrl+goods.thumb" alt="" class="">
								</div>
							</div>
						</div>
						<div class="con-section" v-if="item.type_id == 5">
							<div class="scroll-wrap" ref="scrollDom">
								<div class="yuekan-list">
									<div class="yuekan-item" v-for="(yuekan,index) in item.content" :key="index">
										<img :src="$publicData.ossUrl+yuekan.thumb" alt="">
									</div>
								</div>
							</div>
						</div>
						<div v-if="item.type_id == 3">
							<div class="scroll-wrap" ref="scrollDom">
								<div class="tab-wrap">
									<div :class="fenlei.status ? 'tab-item active': 'tab-item'" v-for="(fenlei,tabIndex) in item.cate" :key="tabIndex">{{ fenlei.content }}</div>
								</div>
							</div>
							<div class="content-item" v-for="(tabItem,index) in item.currentFenlei" :key="index">
								<div class="con-section" v-if="tabItem.type_id == 1">
									<img :src="$publicData.ossUrl+tabItem.content.thumb" alt="" class="">
								</div>
								<div class="con-section" v-if="tabItem.type_id == 2">
									<video controls :src="$publicData.ossUrl+tabItem.content.link" :poster="$publicData.ossUrl+tabItem.content.thumb" style="width:100%;"></video>
								</div>
								<div class="con-section" v-if="tabItem.type_id == 4">
									<div class="goods-list">
										<div class="goods-item" v-for="(goods,index) in tabItem.content" :key="index">
											<img :src="$publicData.ossUrl+goods.thumb" alt="" class="">
										</div>
									</div>
								</div>
								<div class="con-section" v-if="tabItem.type_id == 5">
									<div class="scroll-wrap" ref="scrollDom">
										<div class="yuekan-list">
											<div class="yuekan-item" v-for="(yuekan,index) in tabItem.content" :key="index">
												<img :src="$publicData.ossUrl+yuekan.thumb" alt="">
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>						
					</div>
				</div>
			</div>
			<!-- 加载 -->
			<Spin fix v-if="showLoading"></Spin>
		</div>	
		<!-- 图片上传区域 -->
		<Modal
			v-model="showImgModal"
			:footer-hide="true"
			:mask-closable="false"
			title="图片">
			<add-image ref="addImage" @showImg="onShowImg($event)" @updateContent="onUpdateContent"></add-image>
		</Modal>
		<!-- 视频 -->
		<Modal
			v-model="showVideoModal"
			:footer-hide="true"
			:mask-closable="false"
			title="视频">
			<add-video ref="addVideo" @showVideo="onShowVideo($event)" @updateContent="onUpdateContent"></add-video>
		</Modal>
		<!-- tab区域 -->
		<Modal
			v-model="showTabModal"
			:footer-hide="true"
			:mask-closable="false"
			title="分类">
			<add-tab ref="addTab" @showTab="onShowTab($event)" @updateContent="onUpdateContent"></add-tab>
		</Modal>
		<!-- 列表区域 -->
		<Modal
			v-model="showListModal"
			:footer-hide="true"
			:mask-closable="false"
			title="列表">
			<add-list ref="addList" @showList="onShowList($event)" @updateContent="onUpdateContent"></add-list>
		</Modal>
		<!-- 背景色 -->
		<Modal
			v-model="showSetBgModal"
			title="背景色 "
			@on-ok="setBgColorFun"
        	@on-cancel="showSetBgModal=false">
			<div class="">示例：#000000</div>
			<Input v-model="bgColorVal" placeholder="请输入色值..." style="width: 300px" />
		</Modal>
		<!-- 图片查看 start -->
		<viewer :options="viewerOptions"
				:images="viewerImages"
				@inited="initedViewer"
				class="viewerImageWraper"
				ref="viewerImageWraper">
				<!--  slot-scope="scope" -->
			<template>
				<figure class="images">
				<div class="image-wrapper"
					v-for="img in viewerImages"
					:key="img">
					<img class="image"
						:src="img"
						:data-source="img"
						:alt="img"
						style="display: none;" />
				</div>
				</figure>
			</template>
		</viewer>
		<!-- 图片查看 end -->
	</div>
</template>
<script>
import UploadThumb from "../common/thumb";
import AddImage from './components/addImage.vue'
import AddVideo from './components/addVideo.vue'
import AddTab from './components/addTab.vue'
import AddList from './components/addList.vue'
import BScroll from '@better-scroll/core'
export default {
	name: "zhuanti-index",
	data(){
		return {
			zhuantiData: null,
			zhuanti_id: null,
			showSetBgModal: false,
			bgColorVal: "",
			bgColorSetVal: "",
			showVideoModal: false,
			showListModal: false,
			showImgModal: false,
			showTabModal: false,
			contentArr: [],
			currentFenlei: {},
			zhuantiDataPre: null, // 预览数据
			viewerOptions: {
				toolbar: true,
				url: "data-source"
			},
			viewerImages: [], // v-viewer图片列表
			$viewer: null,
			showLoading: false
		}
	},
	// 计算
	computed: {
		
	},
	mounted() {
		// this.$nextTick(function () {
		// 	// 仅在整个视图都被渲染之后才会运行的代码
		// 	// 横向滚动
		// 	this.init()	
		// })
	},
	// 监听
	watch: {
		
	},
	components: {
		UploadThumb,
		AddImage,
		AddTab,
		AddVideo,
		AddList,
	},
	created: function(){
		this.zhuanti_id = this.$route.params.id;
		this.getZhuantiInfo();
		this.getZhuantiDetail();
	},
	methods: {
		// 初始化
		init(){
			// console.log("元素",this.$refs.scrollDom)
			let scrollDomArr = this.$refs.scrollDom;
			for(let i in scrollDomArr){
				new BScroll(scrollDomArr[i], {
					scrollX: true,
					probeType: 3 // listening scroll event
				});
			}
		},
		// 专题信息
		getZhuantiInfo(){
			let params = {
				zhuanti_id: this.zhuanti_id
			};
			
			this.$api.zhuanti.detail(params).then(res=>{
				if(res.code == 200){
					this.zhuantiInfo = {
						zhuanti_id: res.result.id,
						background_color: res.result.background_color,
						name: res.result.name,
						is_comment: res.result.is_comment
					};
					this.bgColorVal = res.result.background_color;
					this.bgColorSetVal = res.result.background_color;
				}
			})
		},
		// 专题详情
		getZhuantiDetail(){
			var params = {
				zhuanti_id: this.zhuanti_id
			};
			this.$api.zhuanti.blocklist(params).then(res=>{
				if(res.code == 200){
					this.showLoading = false;
					this.bgColorVal = res.result.background_color;
					let list = res.result.blocklist;
					for(let i in list){
						if(list[i].type_id != 3){
							list[i].content = JSON.parse(list[i].content);
						}else{
							let cate = list[i].cate;
							for(let j in cate){
								cate[j].status = 0;	
								if(cate[j].second){ // 实际,只有第一条返回了二级
									cate[j].status = 1;
									let currentFenlei = cate[j].second;
									for(let k in currentFenlei){
										currentFenlei[k].content = JSON.parse(currentFenlei[k].content);
									};
									list[i].currentFenlei = currentFenlei;
								}
							}
						}
					}
					this.zhuantiData = list;
					this.$nextTick(function () {
						// 仅在整个视图都被渲染之后才会运行的代码
						// 横向滚动
						this.init()	
					})
					// console.log("专题",this.zhuantiData);
				}else{
					this.showLoading = false;
					this.$Message.error(res.msg);
				}
			});
			
		},
		// 关闭状态框
		closeStatusFun(){
			this.showVideoModal = false;
			this.showListModal = false;
			this.showImgModal = false;
			this.showTabModal = false;
		},
		// 更新
		onUpdateContent(params){
			console.log("回传的内容",params)
			this.getZhuantiDetail();
			this.closeStatusFun();
		},
		// 图片
		onShowImg(status,block_content_id){
			// 0新增 1编辑
			console.log("状态",status);
			// 新增
			if(status == 0){
				this.showImgModal = true;
				console.log("添加")
				this.$refs.addImage.initFun(0,this.zhuanti_id);
			};
			// 编辑
			if(status == 1){
				this.showImgModal = true;
				// console.log("编辑")
				this.$refs.addImage.initFun(1,this.zhuanti_id,block_content_id)
			}
			if(status == -1){
				// 关闭上传框
				this.showImgModal = false;
				console.log("关闭上传框")
			}
		},
		// 视频
		onShowVideo(status,block_content_id){
			// 新增
			if(status == 0){
				this.showVideoModal = true;
				this.$refs.addVideo.initFun(0,this.zhuanti_id);
			};
			// 编辑
			if(status == 1){
				this.showVideoModal = true;
				console.log("编辑")
				this.$refs.addVideo.initFun(1,this.zhuanti_id,block_content_id)
			}
			if(status == -1){
				this.showVideoModal = false;
			}
		},
		// tab分类
		onShowTab(status,item){
			// 0新增 1编辑
			console.log("状态",status);
			// 新增
			if(status == 0){
				this.showTabModal = true;
				this.$refs.addTab.initFun(0,this.zhuanti_id);
				console.log("添加")
			};
			// 编辑
			if(status == 1){
				this.showTabModal = true;
				console.log("编辑")
				this.$refs.addTab.initFun(1,this.zhuanti_id,item)
			}
			// 关闭
			if(status == -1){
				this.showTabModal = false;
			}
		},
		// 选择tab
		selectTabFun(block_id,id){
			let params = {
				cate_id: id
			};
			this.$api.zhuanti.catecontent(params).then(res=>{
				if(res.code == 200){
					// 更新当前项
					let currentFenlei = res.result;
					for(let j in currentFenlei){
						currentFenlei[j].content = JSON.parse(currentFenlei[j].content)
					};
					// 更新总表
					let list = this.zhuantiData;
					for(let i in list){
						if(list[i].type_id == 3 && list[i].block_id == block_id){
							list[i].currentFenlei = currentFenlei;
							let item = list[i].cate;
							for(let k in item){
								item[k].status = 0;
								if(item[k].cate_id == id){
									item[k].status = 1;
								}
							}
						}
					};
					this.zhuantiData = list;
					this.$nextTick(function () {
						// 仅在整个视图都被渲染之后才会运行的代码
						// 横向滚动
						this.init()	
					})
					console.log("总表",this.zhuantiData)
				}else{
					this.$Message.error(res.msg)
				}
			})
		},
		// 商品
		onShowList(status,type,block_content_id){
			// 0新增 1编辑
			if(status == 0){
				this.showListModal = true;
				this.$refs.addList.initFun(0,type,this.zhuanti_id,block_content_id);
				console.log("添加")
			};
			// 编辑
			if(status == 1){
				this.showListModal = true;
				console.log("编辑")
				this.$refs.addList.initFun(1,type,this.zhuanti_id,block_content_id)
			};
			// 关闭
			if(status == -1){
				this.showListModal = false;
			}
		},
		// 编辑
		editFun(item){
			// console.log("编辑",item);
			if(item.type_id == 1){
				console.log("图片")
				// 图片
				this.onShowImg(1,item.block_content_id)
			}else if(item.type_id == 2){
				console.log("视频")
				// 视频
				this.onShowVideo(1,item.block_content_id)
			}else if(item.type_id == 3){
				console.log("分类")
				// 分类
				this.onShowTab(1,item)
			}else if(item.type_id == 4){
				console.log("竖排")
				// 竖排
				this.onShowList(1,4,item.block_content_id)
			}else if(item.type_id == 5){
				console.log("横排")
				// 横排
				this.onShowList(1,5,item.block_content_id)
			}
		},
		// 删除
		delFun(item,is_erji){
			console.log("删除",item);
			this.$Modal.confirm({
				title: "警告",
				content: "<p>此操作不可恢复，三思而后行...</p>",
				onOk: ()=>{
					let params = null;
					if(is_erji){
						// 删除分类下的内容
						params = {
							block_content_id: item.block_content_id
						};
					}else{
						// 删除模块内容
						params = {
							block_id: item.block_id
						};
					}
					this.$api.zhuanti.blockremove(params).then(res=>{
						if(res.code == 200){
							this.onUpdateContent();
						}else{
							this.$Message.error(res.msg);
						}
					})
				}
			})
		},
		// 设置背景色
		setBgColorFun(){
			if(!this.bgColorVal){
				this.$Message.warning("色值未设置");
				return;
			}else{
				this.zhuantiInfo.background_color = this.bgColorVal;
				this.$api.zhuanti.edit(this.zhuantiInfo).then(res=>{
					if(res.code == 200){
						this.bgColorSetVal = this.bgColorVal;
						this.showSetBgModal = false;
					}else{
						this.$Message.error(res.msg);
					}
				})
			}
		},
		// 预览
		previewFun(){
			let str = JSON.stringify(this.zhuantiData); // 不做实时同步
			this.zhuantiDataPre = JSON.parse(str);
			this.$nextTick(function () {
				// 仅在整个视图都被渲染之后才会运行的代码
				// 横向滚动
				this.init()	
			})
		},
		// 发布
		publishFun(){
			this.$api.zhuanti.updstatus({zhuanti_id: this.zhuanti_id}).then(res=>{
				if(res.code == 200){
					this.$Message.success(res.msg);
					this.$router.back()
				}else{
					this.$Message.error(res.msg);
				}
			})
		},
		// 初始化Viewer
		initedViewer (viewer) {
			this.$viewer = viewer;
		},
		// 展示大图
		showViewerFun(img){
			this.viewerImages = [img];
			this.$viewer.show();
		},
		// 上移或下移
		moveFun(item,type,is_parent){
			// console.log("item===",item);
			// console.log("is_parent===",is_parent);
			this.showLoading = true;
			let params = {
				type: type // 0下移 1上移
			};
			if(is_parent){
				// 分类下的内容
				params.block_content_id = item.block_content_id;
			}else{
				// 模块
				params.block_id = item.block_id;
			}
			this.$api.zhuanti.blocksort(params).then(res=>{
				if(res.code == 200){
					// 更新
					this.getZhuantiDetail();
				}else{
					this.$Message.error(res.msg);
					this.showLoading = false;
				}
			})
		}
	}
}
</script>
<style>
	.zhuanti {
		overflow-x: auto;
	}
	.zhuanti img{
		max-width: 100%;
		display: block;
	}
	.zhuanti .sec_name{
		font-size: 16px;
	}
	.zhuanti_con{
		display: flex;
		align-items: flex-start;

	}
	.content{
		width: 750px;
		padding: 0 30px;
	}
	.content-item{
		position: relative;
		margin-top: 10px;
		min-height: 160px;
	}
	.tab-wrap{
		/* display: flex;
		align-items: center;
		flex-wrap: nowrap; */
		/* justify-content: space-around; */
		display: inline-block;
		/* height: 100px; */
		color: #000000;
		min-height: 160px;
	}
	.tab-wrap .tab-item{
		display: inline-block;
		min-width: 80px;
		text-align: center;
		padding-right: 10px;
		/* flex-shrink: 0; */
		margin: 0 auto;
	}
	.tab-wrap .tab-item.active{
		color: red;
	}
	.tool_list.setting{
		display: flex;
		flex-wrap: wrap;
	}
	.tool_list.setting{
		width: 200px;
	}
	.tool_list.setting .tool_item{
		width: 50%;
	}
	.tool_list:not(:first-child){
		margin-top: 10px;
		border-top: 1px dashed #cccccc;
	}
	.tool_list .tool_item{
		margin-top: 10px;
	}
	.tool_list .tool_item .tool_item_t{
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.tool_list .tool_item .tool_item_m{
		display: flex;
		align-items: flex-start;
	}
	.tool_list .tool_item .tool_item_tu{
		width: 80px;
		height: 80px;
		overflow: hidden;
	}
	.tool_item .tool_item_tu .example-tu{
		width: 80px;
	}
	.goods-list{
		display: flex;
		flex-wrap: wrap;
		/* align-items: center;
		justify-content: space-around; */
	}
	.goods-list .goods-item{
		margin: 10px 25px 0 0;
	}
	.goods-list .goods-item,.goods-list .goods-item img{
		width: 320px;
		/* height: 490px; */
	}
	.scroll-wrap{
		/* width: 690px;
		height: 200px;*/
		position: relative;
		white-space: nowrap;
		width: 690px;
		overflow: hidden;
	}
	.yuekan-list{
		/* width: 690px; */
		/* display: flex;
		flex-wrap: nowrap;  */
		/* overflow-x: scroll; */
		display: inline-block;
	}
	.yuekan-list .yuekan-item,.yuekan-list .yuekan-item img{
		width: 320px;
		/* height: 80px; */
	}
	.yuekan-list .yuekan-item{
		margin-right: 10px;
		/* flex-shrink: 0; */
		display: inline-block;
	}
	.action-wrap{
		position: absolute;
		top: 0px;
		right: -60px;
		display: flex;
		flex-direction: column;
	}
	.action-wrap button:not(:first-child){
		margin-top: 10px;
	}
	.content.preview{
		width: 375px;
		height: 667px;
		padding: 0 15px;
		border: 1px solid #cccccc;
		overflow-y: scroll;
		overflow-x: hidden;
	}
	.preview .scroll-wrap{
		border-radius: 10px;
		background: #ffffff;
	}
	.preview .tab-wrap{
		/* width: 100%; */
		height: 40px;
		line-height: 40px;
		background: #ffffff;
		border-radius: 10px;
		min-height: unset;
		/* color: #000000; */
	}
	.preview .goods-list .goods-item,.preview .goods-list .goods-item img{
		width: 160px;
	}
	.preview .scroll-wrap{
		width: 320px;
	}
	.preview .yuekan-list .yuekan-item,.preview .yuekan-list .yuekan-item img{
		width: 160px;
	}
	.preview .goods-list .goods-item{
		margin: 4px 6px 0 0;
	}
	.preview .content-item{
		min-height: unset;
	}
	.content.sec-edit{
		width: 375px;
		height: 667px;
		padding: 0;
		padding-right: 6px;
		overflow-y: scroll;
		/* border: 1px solid red; */
	}
	.sec-edit .goods-list .goods-item,.sec-edit .goods-list .goods-item img{
		width: 120px;
	}
	.sec-edit .scroll-wrap{
		width: 280px;
	}
	.sec-edit .yuekan-list .yuekan-item,.sec-edit .yuekan-list .yuekan-item img{
		width: 120px;
	}
	.sec-edit .goods-list .goods-item{
		margin: 4px 8px 0 0;
	}
	.sec-edit .action-wrap{
		right: 0px;
	}
	.sec-edit .scroll-wrap{
		width: 280px;
	}
	.sec-edit .con-section{
		width: 280px;
	}
	.goods-list .goods-item:nth-of-type(2n){
		margin-right: 0;
	}
	.zhuanti .cursor{
		cursor: pointer;
	}
	/* .preview .tab-wrap .tab-item{
		min-width: 160px;
	} */
</style>